exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-06c5ecc0]{padding:10px;background:#fff;border-radius:10px;margin-bottom:20px}.box .item_box[data-v-06c5ecc0]{margin-top:10px;font-size:16px}[data-v-06c5ecc0] .dialog_box{border-radius:10px}[data-v-06c5ecc0] .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.from_box[data-v-06c5ecc0]{padding:0 80px}.name_box[data-v-06c5ecc0]{font-size:16px;font-weight:600}", ""]);

// exports
